import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: new Array(100).fill({}),
  documentId: "",
  csvName: "", // <- name in storage
  fileName: "", // <- name in firestore
  lastAutosaveDate: "",
  // columns: initialColumns,
  graphs: {
    histogram: false,
    IVP: false,
    boxplot: false,
  },
  confidenceLevel: "",
  hypothesizedMean: "",
  isLoading: false,
  analysisAndGraphs: [],
};

export const dataTableSlice = createSlice({
  name: "dataTable",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    clearData: (state) => {
      state.data = new Array(100).fill({});
      state.fileName = "";
      state.lastAutosaveDate = "";
      state.graphs = {
        histogram: false,
        boxplot: false,
        IVP: false,
      };
      state.hypothesizedMean = "";
      state.confidenceLevel = "";
      state.analysisAndGraphs = [];
    },
    setDocumentId: (state, action) => {
      state.documentId = action.payload;
    },
    setFileName: (state, action) => {
      state.fileName = action.payload;
    },
    setCsvName: (state, action) => {
      state.csvName = action.payload;
    },
    setLastAutosaveDate: (state, action) => {
      state.lastAutosaveDate = action.payload;
    },
    setConfidenceLevel: (state, action) => {
      state.confidenceLevel = action.payload;
    },
    setHypothesizedMean: (state, action) => {
      state.hypothesizedMean = action.payload;
    },
    // setAnalysisAndGraphs: (state, action) => {
    //   state.analysisAndGraphs = action.payload;
    // },
    // addAnalysisAndGraphs: (state, action) => {
    //   state.analysisAndGraphs.push(action.payload);
    // },
    // updateAnalysisAndGraphs: (state, action) => {
    //   const analysisAndGraphs = state.analysisAndGraphs;
    //   const payload = action.payload;
    //   //Find index of specific object using findIndex method.
    //   const testIndex = analysisAndGraphs.findIndex(
    //     (obj) => obj.id === payload.id
    //   );
    //   //Update object's property.
    //   analysisAndGraphs[testIndex] = payload;
    // },
    // removeAnalysisAndGraphs: (state, action) => {
    //   state.analysisAndGraphs = state.analysisAndGraphs.filter(
    //     (test) => test.id === action.payload
    //   );
    // },
    setIsLoading: (state) => {
      state.isLoading = !state.isLoading;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setData,
  clearData,
  setFileName,
  setLastAutosaveDate,
  setDocumentId,
  setCsvName,
  // setColumns,
  setConfidenceLevel,
  setHypothesizedMean,
  // setAnalysisAndGraphs,
  // addAnalysisAndGraphs,
  // updateAnalysisAndGraphs,
  // removeAnalysisAndGraphs,
  setIsLoading,
} = dataTableSlice.actions;

export default dataTableSlice.reducer;
